import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { DataServiceService } from '../../services/student-services/common/data-service.service';
import { LoaderService } from '../../services/common/loader.service';
import { USER_KEY } from '../../constants/user-constants';
import { HeaderService } from '../../services/common/header.service';

@Component({
	selector: 'app-home-viewonly',
	templateUrl: './home-viewonly.component.html',
	styleUrls: [ './home-viewonly.component.scss' ]
})
export class HomeViewOnlyComponent implements OnInit {
	@HostBinding('class') elementClass = 'app-home-viewonly';

	// pass the selected task details to the checklist component.
	@Input() selectedTask;

	// variable declarations
	public showSettings = false;
	public getTokenResult;
	public showOnBoarding = false;
	public currentUser = {};
	public dataLength = 0;
	public showSidebar = false;
	public onboardStudentData;
	public HUD = {
		percentageHUD: 0,
		pacingText: ''
	};

	public studentDetails = {
		studentData: null,
		studentPhases: [],
		phasesData: [],
		taskData: [],
		subTaskData: [],
		goal_data: [],
		subtask_goal: [],
		goal_Date: null
	};
	public studentRecords = {
		phases: []
	};
	public sidebarData;
	public isLoading = true;
	public pageSelector = '';
	public activeView = {
		phase: '',
		task: ''
	};
	public currentPage;

	public phases = [];
	public tasks = [];
	public subtasks = [];

	public viewOnlyData = true;

	constructor(
		private readonly dataService: DataServiceService,
		private readonly loaderService: LoaderService,
		private readonly headerService: HeaderService
	) {
		this.headerService.hideStaffHeader();
	}

	ngOnInit() {
		sessionStorage.removeItem('updated_at');
		sessionStorage.removeItem('phasesCount');

		this.getTemplateAndDataForUI(localStorage.getItem(USER_KEY.CURRENT_TEMPLATE_ID));
	}

	public setAllCollectionData(contentfulPhaseIds) {
		// Loop through contentful phase ids and get phases by this id
		contentfulPhaseIds.forEach((contentfulPhaseId, phaseIndex) => {
			this.dataService
				.getCollectionDocWithIdByWhere('phases', 'contentful_id', '==', contentfulPhaseId)
				.subscribe(async (phaseDocsRef) => {
					// Storing phases into phases array
					phaseDocsRef.forEach(async (phase) => {
						const phaseData = phase.data();
						phaseData._id = phase.id;
						this.phases.push(phaseData);

						// Storing tasks into tasks array
						phaseData.contentful_task_ids.forEach((contentfulTaskId, taskindex) => {
							this.dataService
								.getCollectionDocWithIdByWhere('tasks', 'contentful_id', '==', contentfulTaskId)
								.subscribe((taskDocsRef) => {
									taskDocsRef.forEach(async (task) => {
										const taskData = task.data();
										taskData._id = task.id;
										this.tasks.push(taskData);

										// Storing subtasks into subtasks array
										taskData.contentful_subtask_ids.forEach((contentfulSubtaskId, subtaskIndex) => {
											this.dataService
												.getCollectionDocWithIdByWhere(
													'subtasks',
													'contentful_id',
													'==',
													contentfulSubtaskId
												)
												.subscribe((subtaskDocsRef) => {
													subtaskDocsRef.forEach((subtask) => {
														const subtaskData = subtask.data();
														subtaskData._id = subtask.id;
														this.subtasks.push(subtaskData);
													}); // End of subtask foreach

													if (
														subtaskIndex === taskData.contentful_subtask_ids.length - 1 &&
														phaseIndex === contentfulPhaseIds.length - 1 &&
														taskindex === phaseData.contentful_task_ids.length - 1
													) {
														this.getAllCollections();
													}
												}); // End of subtask data service
										}); // End of contentful_subtask_ids foreach
									}); // End of tasks foreach
								}); // End of tasks data service
						}); // End of contentful_task_ids foreach
					}); // End of phases foreach
				}); // End of phases data service
		}); // End of contentfulPhaseIds foreach
	}

	// get all collections
	public getAllCollections() {
		this.studentRecords['phases'] = [];
		if (this.phases.length > 0) {
			this.studentDetails.phasesData = this.phases;
			this.showSidebar = true;
			if (this.tasks.length > 0) {
				this.studentDetails.taskData = this.tasks;

				if (this.subtasks.length > 0) {
					this.studentDetails.subTaskData = this.subtasks;
					this.studentDetails.studentPhases.forEach((studentPhase) => {
						this.studentDetails.phasesData.forEach((phase) => {
							phase.currentPhase = false;
							if (studentPhase === phase.contentful_id) {
								phase.tasks = phase.tasks ? phase.tasks : [];
								phase.contentful_task_ids.forEach((phaseTask) => {
									this.studentDetails.taskData.forEach((task) => {
										task.currentTask = '';
										if (phaseTask === task.contentful_id) {
											task.subtasks = task.subtasks ? task.subtasks : [];
											task.contentful_subtask_ids.forEach((tasksub) => {
												this.studentDetails.subTaskData.forEach((subtask) => {
													if (tasksub === subtask.contentful_id) {
														task.subtasks.push(subtask);
													}
												});
											});
											phase.tasks.push(task);
										}
									});
								});
								this.studentRecords['phases'].push(phase);
							}
						});
					});
					this.showActivePhaseAndTask(this.studentRecords.phases);
				}
			}
		}
	}

	public showActivePhaseAndTask(data) {
		this.redirectToDefaultTask(data);
	}

	/**
   * @description If there is any mismatch between current_phase and current_task then redirect to First Pahse and First task
   * @param data (Object) Student data
   */
	private redirectToDefaultTask(data) {
		data[0].currentPhase = true;
		this.activeView.phase = data[0].contentful_id;
		this.activeView.task = data[0].tasks[0].contentful_id;
		this.activeTask(data[0].tasks[0]);
	}

	/**
   * @description EvenEmit This function will redirect the user ro next pending task without refresh
   * @param currentPhaseTask (Object) Holds next pending task and phase information
   */
	activePhaseAndTaskEvent(currentPhaseTask) {
		if (currentPhaseTask.nextPhase && currentPhaseTask.nextTask) {
			this.activeView.phase = currentPhaseTask.nextPhase.contentful_id;
			this.activeView.task = currentPhaseTask.nextTask.contentful_id;
			this.activeTask(currentPhaseTask.nextTask);
		}
	}

	/**
   * @description get template data and then the other details to display in the UI.
   * @param templateId template id of the student which is used to fetch the data
   * from the firestore collection starting with phases.
   */
	public getTemplateAndDataForUI(templateId) {
		this.currentPage = this.getCurrentPage();
		this.loaderService.show();
		this.dataService.getTemplate(templateId).subscribe(
			(templateData: any) => {
				this.studentDetails.studentPhases = templateData.contentful_phase_ids;
				this.setAllCollectionData(templateData.contentful_phase_ids);
				this.loaderService.hide();
			},
			(error) => this.loaderService.hide()
		);
	}

	/**
   * @description display the current subtask in the checklist component.
   * @param task current task whose subtasks are displayed.
   */

	public activeTask(task) {
		this.currentPage = 'student';
		this.selectedTask = task;
		this.isLoading = false;
	}

	navigateTo(path: string) {
		this.currentPage = path;
	}

	/**
   * @description get the current page for toggling the components.
   * Note: for toggling settings,checklist,faq, resources.
   */
	public getCurrentPage() {
		return location.href.split('#')[1].split('/')[1];
	}
}
